<template>
  <transition :name="closeTransition ? '' : 'md-fade-center'">
    <span
      class="zk-tag"
      :class="[type ? 'zk-tag--' + type : '', {'is-hit': hit}]">
      <slot></slot>
      <i class="zk-tag__close zk-icon-close"
        v-if="closable"
        @click="handleClose"></i>
    </span>
  </transition>
</template>
<script>
  export default {
    name: 'ZkTag',
    props: {
      text: String,
      closable: Boolean,
      type: String,
      hit: Boolean,
      closeTransition: Boolean
    },
    methods: {
      handleClose(event) {
        this.$emit('close', event);
      }
    }
  };
</script>



// WEBPACK FOOTER //
// tag.vue?453a5d7b